import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { Enums } from '../../../../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-work-shift-user-popover',
  templateUrl: './work-shift-user-popover.component.html',
  styleUrls: ['./work-shift-user-popover.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WorkShiftUserPopoverComponent implements OnInit {
  Enums = Enums;
  @Input() user;
  @Input() templateFilter;

  constructor() {}

  ngOnInit() {}

  toggleWithUserContext(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }
}
